// extracted by mini-css-extract-plugin
export default {"shared":"scenes_shared__xYi6N"};